<template>
    <div>
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
        <div style="padding-left: 20%; padding-right: 20%; margin-bottom: 10%;margin-top:10%; width:100%;">
      

                
                
                <v-tabs v-model="tabs" vertical color="black" >

                  
         <table>
             <tr>
                 <td>
                     <div style="margin:10%;padding-right:10px">
                         <svg width="35" height="35" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                             <g>
                                 <path d="m297.24 1032.4h605.53c56.859 0 102.94-46.078 102.94-102.94 0-174.94-141.84-316.78-316.78-316.78l-177.98-0.046875c-174.94 0-316.78 141.84-316.78 316.78 0 56.906 46.219 102.98 103.08 102.98z" />
                                 <path d="m780.89 333.89c16.219 99.891-51.609 194.02-151.55 210.24-99.891 16.219-194.02-51.656-210.19-151.55-16.219-99.891 51.609-194.02 151.5-210.24 99.891-16.219 194.02 51.656 210.24 151.55" />
                             </g>
                         </svg>
                     </div>
                 </td>

                 <td >
                     <div class="tituloTab" >
                         <v-tab id="idTab1" @click="onTab1" style="margin-left: 0px; padding-left:0;">
                             <span class="e-n-tab-icon" id="idSpan1" style="font-family: Heebo; font-size: 18px; color: black; font-weight: normal; text-transform: capitalize; margin-left: 0px; padding-left: 5%;text-align: left ;display:inline-block; width:100%">
                                 Acceso          
                             </span>

                         </v-tab>
                     </div>
                 </td>
             </tr>
        <tr>
            <td>
                <div style="margin:10%;padding-right:10px;">
                    <svg width="35" height="35" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <path d="m571.68 372.72c-64.801-64.68-170.28-64.68-235.08 0-64.801 64.801-64.801 170.28 0 235.08 47.762 47.762 118.92 61.801 181.44 35.879 8.8789-3.7188 19.32-1.6797 26.16 5.1602l227.28 227.28 68.516 0.003906v-105.72h-27.238c-13.32 0-24-10.68-24-24v-27.238h-27.238c-13.32 0-24-10.68-24-24v-27.238h-27.238c-6.3594 0-12.48-2.5195-17.039-6.9609l-80.52-80.641c-6.8398-6.8398-9-17.16-5.1602-26.16 25.914-62.398 11.754-133.68-35.887-181.44zm-166.56 92.52c-13.199 0-24-10.68-24-24 0-13.199 10.801-24 24-24 13.199 0 24 10.801 24 24 0 13.32-10.801 24-24 24z" />
                            <path d="m981.84 218.28c-102-102-237.6-158.16-381.84-158.16s-279.84 56.16-381.84 158.16-158.16 237.6-158.16 381.84c0 13.199 10.801 24 24 24s24-10.801 24-24c0-131.4 51.121-255 144.12-347.88 92.879-92.883 216.48-144.12 347.88-144.12s255 51.121 347.88 144.12c93 92.879 144.12 216.48 144.12 347.88 0 131.4-51.121 255-144.12 347.88-177 177-456.24 190.56-649.08 41.039h38.16c13.199 0 24-10.801 24-24 0-13.199-10.801-24-24-24h-101.88c-13.199 0-24 10.801-24 24v101.88c0 13.199 10.801 24 24 24s24-10.801 24-24v-47.879c98.879 80.52 219.96 120.84 340.92 120.84 138.24 0 276.6-52.68 381.84-157.92 102-102 158.16-237.6 158.16-381.84 0-144.24-56.16-279.84-158.16-381.84z" />
                        </g>
                    </svg>
                </div>
            </td>
            <td >
                <div class="tituloTab" >
                    <v-tab  id="idTab2" @click="onTab2" style="margin-left: 0px; padding-left:0;">
                        <span class="e-n-tab-icon" id="idSpan2" style="font-family: Heebo; font-size: 18px; color: black; font-weight: normal; text-transform: capitalize; margin-left: 0; padding-left: 5%; text-align: left; display: inline-block; width: 100% ">
                            Reestablecer clave
                        </span>

                    </v-tab>
                </div>
            </td>
        </tr>
    </table>
    
             
             

                    <v-tab-item >
                        <v-card flat style="margin-top:0;margin-left:10%">
                            <v-card-text>


                                <div class="row">
                                    <div class="form-row" >
                                        <h2 class="title--l align-left" style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold ;">Acceso Empresas</h2>
                                        <h3 class="title--m align-left" style="font-family: Heebo; font-size: 18px; font-weight: normal; color: black">Acceso empresas registradas en el Servicio Técnico</h3>
                                        <h4 class="title--s align-left" style="font-family: Heebo; font-size: 16px; font-weight: normal; color: black">Introduzca su usuario y contraseña</h4>
                                    </div>
                                </div>
                             

                                <div class="form-row" style="margin-top: 20px; padding-left: 0;">
                                    
                                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                            <input id="form-field-company" style="color: #606060" v-model="login.user" maxlength="40" size="60" type="text" name="form_fields[company]"  class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Usuario ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                            <input id="form-field-company" style="color: #606060" v-model="login.password" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Clave ">
                                        </div>
                                    </div>
                                </div>
                            
                                <div style="padding-top: 20px; padding-left: 0;" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
                                    <button @click="acceder" style="font-family: Heebo;font-size:16px; height:30px;width:200px">
                                        Acceder
                                    </button>
                                </div>
                 
                              
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat style="margin-top: 0; margin-left: 10%">
                            <v-card-text v-if="!okCredentials">
                                <div class="row">
                                    <h2 class="title--l align-left" style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold ;">Acceso Empresas</h2>
                                    <h3 class="title--m align-left" style="font-family: Heebo;font-size: 18px; font-weight: normal; color: black">Reestablecer contraseña</h3>
                                    <h4 class="title--s align-left" style="font-family: Heebo; font-size: 16px; font-weight: normal; color: black">Escribe el usuario, dirección de correo electrónico y CIF de la empresa con la que estás dado de alta en el sistema y te permitiremos crear una clave de acceso nueva.</h4>

                                </div>

                                <div class="row" style="overflow-x: auto;">

                                   

                                    <table style="height: 300px;margin-top: 20px;">
                                        <tr>
                                            <td>
                                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                                        <input id="form-field-company" style="color: #606060" v-model="credentials.user" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Usuario ">
                                                    </div>
                                                </div>

                                            </td>
                                           
                                            <td>
                                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                                        <input id="form-field-company" style="color: #606060" v-model="credentials.mail" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Email ">
                                                    </div>
                                                </div>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                                        <input id="form-field-company" style="color: #606060" v-model="credentials.cif" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="CIF/NIF ">
                                                    </div>
                                                </div>
                                               

                                            </td>

                                            <td>
                                            </td>
                                        </tr>

                                      
                                        <tr>
                                            <td>
                                                <div style="margin-top: 20px;padding-left:0;" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
                                                    <button @click="comprobarCredenciales" style="font-family: Heebo;font-size:16px; height:30px;width:200px">
                                                        Comprobar
                                                    </button>
                                                </div>

                                            </td>
                                            <td>
                                               
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </v-card-text>

                            <v-card-text  style="margin-top: 0; margin-left: 10%" v-else>

                                <div class="row">
                                    <h4 class="title--s align-center" style="font-family: Heebo; font-size: 18px; font-weight: normal">Escribe una nueva contraseña</h4>
                                </div>
                                <div class="row">

                                    <div class="form-row" style="padding-left: 0; margin-top: 20px;">
                                        <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                            <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                                <input id="form-field-company" style="color: #606060" v-model="credentials.newPassword1" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Contraseña ">
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div class="form-row" style="padding-left: 0;">
                                        <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                            <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                                <input id="form-field-company" style="color: #606060" v-model="credentials.newPassword2" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Repetir contraseña ">
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div style="margin-top: 20px; padding-left: 0;" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
                                        <button @click="cambiarPassword" style="font-family: Heebo;font-size:16px; height:30px;width:200px">
                                            Enviar
                                        </button>
                                    </div>

                                   

                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
                <br /><br />
                <br /><br />
            </div>
          

        <pie></pie>
    </div>
</template>

<script>

    let instanciaVue = {
        components: {
            // encabezado: () => import("@/components/newEncabezado"),
            // pie: () => import('@/components/newPie')
            encabezado: () => import("@/components/newEncabezado"),
            breadcrum: () => import("@/components/breadcrum"),
            pie: () => import("@/components/newPie"),
        },

        data: () => ({
            name: 'empresasCR',
            texto: '',
            titulo: 'Acceso Empresas',
            tabs: 0,
            login: {
                aplicationCode: 'WSATT',
                user: '',
                password: ''
            },
            credentials: {
                aplicationCode: 'WSATT',
                user: '',
                mail: '',
                cif: '',
                okCredentials: false,
                newPassword1: '',
                newPassword2: ''
            }
        }),
        computed: {
            checkPasswords() { return this.credentials.newPassword1 == this.credentials.newPassword2 },
            okCredentials: {
                get() { return this.credentials.okCredentials },
                set(valor) { this.credentials.okCredentials = valor }
            }
        },
        mounted: function () {
            var tab1 = document.getElementById('idTab1');
            tab1.style.backgroundColor = '#9be51a';
            var span1 = document.getElementById('idSpan1');
            span1.style.fontWeight = "bold";
            span1.style.fontFamily = "Heebo";

        },

        methods: {

            onTab1() {
                var tab2 = document.getElementById('idTab2');
                tab2.style.backgroundColor = 'white';
                var span2 = document.getElementById('idSpan2');
                span2.style.fontWeight = "400";

                var tab1 = document.getElementById('idTab1');
                tab1.style.backgroundColor = '#9be51a';
                var span1 = document.getElementById('idSpan1');
                span1.style.fontWeight = "bold";
                span1.style.fontFamily = "Heebo";
            },

            onTab2() {           
                var tab1 = document.getElementById('idTab1');
                tab1.style.backgroundColor = 'white';
                var span1 = document.getElementById('idSpan1');
                span1.style.fontWeight = "400";

                var tab2 = document.getElementById('idTab2');
                tab2.style.backgroundColor = '#9be51a';   
                var span2 = document.getElementById('idSpan2');
                span2.style.fontWeight = "bold";
                span2.style.fontFamily = "Heebo";
            },
  
            acceder() {
                this.$API.login(this.login).then(response => {
                    if (response != '') {
                        this.$bus.login = true
                        this.$bus.formulario.company = true
                        this.$bus.formulario.codigoEmpresa = response.company.code
                        this.$bus.formulario.recogida.company = response.company.companyName
                        this.$bus.formulario.recogida.name = response.company.name
                        this.$bus.formulario.recogida.telephone = response.company.telephone
                        this.$bus.formulario.recogida.mail = response.company.mail
                        this.$bus.formulario.recogida.country = response.company.country
                        this.$bus.formulario.recogida.town = response.company.town.toUpperCase()
                        this.$bus.formulario.recogida.zipcode = response.company.zipcode
                        this.$bus.formulario.recogida.address = response.company.address
                        this.$bus.formulario.recogida.province = response.company.province
                        this.$bus.formulario.recogida.cif = response.company.cif
                        this.$bus.formulario.entrega.name = response.company.name
                        this.$bus.formulario.entrega.telephone = response.company.telephone
                        this.$bus.formulario.entrega.mail = response.company.mail
                        this.$bus.formulario.entrega.country = response.company.country
                        this.$bus.formulario.entrega.cif = response.company.cif
                        this.$router.push('/empresaCR')
                    }
                })
            },
            comprobarCredenciales() {
                this.$API.comprobarCredenciales(this.credentials).then(response => {
                    if (response != '' && response.valido) {
                        this.okCredentials = true
                        console.log("Credenciales OK")
                    }
                })
            },
            cambiarPassword() {
                if (this.checkPasswords == true) {
                    this.$API.cambiarPassword(this.credentials).then(response => {
                        if (response != '' && response.valido) {
                            this.cardLogin = true
                            this.credentials.user = ''
                            this.credentials.mail = ''
                            this.credentials.cif = ''
                            this.credentials.okCredentials = false
                            console.log("Contraseña cambiada con exito")
                        }
                        this.credentials.newPassword1 = ''
                        this.credentials.newPassword2 = ''
                    })
                } else {
                    console.log("Las contraseñas no coinciden")
                }
            },
        }
    }

    export default instanciaVue

</script>

<style>
    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }
    .v-btn__content {
        font-size: 1.5rem;
    }

    ::placeholder {
        font-family: Heebo;
        color: black;
        font-weight: normal
    }


    /*
 #searchbox:focus {
        border: 1px solid black;
        border-radius: 4px;
    }
   */
   

    .tituloTab {
        border-bottom: 3px solid #9be51a;
        padding-bottom: 2%;
        padding-top: 2%;
        margin-left: 0;
        padding-left: 0;
    
    }

   

</style>

